import protectedWeb3Request from '../../helpers/protectedWeb3Request';
import axios from 'axios';

const baseUrl = process.env.REACT_APP_WEB3_BE_ENDPOINT;

// Protected requests
export const getNfts = params =>
  protectedWeb3Request.get(`${baseUrl}/api/v1/nfts`, { params });

export const getNftCollectionStats = params =>
  protectedWeb3Request.get(`${baseUrl}/api/v1/nft/stats/collection`, {
    params,
  });

// Public request
const publicAuthConfig = {
  headers: {
    Authorization: process.env.REACT_APP_WEB3_BE_AUTHORIZATION_TOKEN,
  },
};

export const getAuthTokens = payload =>
  axios.post(`${baseUrl}/api/v1/auth`, payload);

export const getNft = (params = {}) =>
  axios.get(`${baseUrl}/api/v1/nft`, {
    ...publicAuthConfig,
    params: params,
  });
